<template>
    <el-dialog :close-on-click-modal="false"   title="备注" :visible.sync="noteData.visible" v-if="noteData.visible"
               width="400px" @close="closeDialog">
        <el-form :model="noteForm" ref="noteForm" label-width="100px">
            <el-form-item label="类型:">
                <el-radio-group v-model="noteForm.type" prop="type" @change="typeChange">
                    <el-radio :label="0">客服备注</el-radio>
                    <el-radio :label="1">拣货说明</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="内容:" style="margin-right: 20px" prop="note">
                <el-input type="textarea" :rows="5" size="small" v-model="noteForm.note"></el-input>
            </el-form-item>
            <el-form-item label="颜色"  v-show="noteForm.type == '1'">
                <el-row class="colorClass">
                    <el-button class="color_0"  style="background: #009926;" circle @click="colorSelect($event,'#009926')"></el-button>
                    <el-button class="color_1"  style="background: #F00;" circle  @click="colorSelect($event,'#F00')"></el-button>
                    <el-button class="color_2"  style="background: #0005FD;" circle  @click="colorSelect($event,'#0005FD')"></el-button>
                    <el-button class="color_3"  style="background: #FF5800;" circle  @click="colorSelect($event),'#FF5800'"></el-button>
                    <el-button class="color_4"  style="background: #8E0075;" circle  @click="colorSelect($event,'#8E0075')"></el-button>
                    <el-button class="color_5"  style="background: #FF6666" circle  @click="colorSelect($event,'#FF6666')"></el-button>
                    <el-button class="color_6"  style="background: #FFCAC5" circle  @click="colorSelect($event,'#FFCAC5')"></el-button>
                    <el-button class="color_7"  style="background: #00D0FF" circle @click="colorSelect($event,'#00D0FF')"></el-button>
                </el-row>
            </el-form-item>
        </el-form>
        <div style="display: flex;font-size: 12px;justify-content: center">
            <div style="background-color: #009999;color: white;width: 40px;text-align: center">说明:</div>
            <div><span>「拣货说明」在打印时，会打印到拣货单 </span></div>
        </div>
        <div slot="footer" class="dialog-footer dig-2-ft">
            <el-button type="primary" size="small" @click="submitRemark">提 交</el-button>
            <el-button  size="small" @click="cancel">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {saveRemark,getOrderJHNote} from '../../api/order/all'
    export default {
        name: "orderNote",
        props:{
            noteData:{
                type:Object,
                default:function () {
                    return{
                        visible:false,
                        appId:null,
                        source:null
                    }
                }
            },
            loadNoteList:{
                type:Function,
                default:null
            }
        },
        data(){
            return{
                colorArr:['#009926','#F00','#0005FD','#FF5800','#8E0075','#FF6666','#FFCAC5','#00D0FF'],
                noteForm:{
                    id:null,
                    type:1,
                    note:null,
                    color:null
                },
                jh_note:{
                    id:null,
                    content:null,
                    color:null
                }
            }
        },
        methods:{
            submitRemark(){
                let that =this;
                that.noteForm.appId= that.noteData.appId;
                //存入S_REMARK
                saveRemark(that.noteForm).then((res) => {
                    if (res.code === 200) {
                        this.msgSuccess("提交成功");
                        this.cancel();
                        if(this.noteData.source == 0 && this.loadNoteList){
                            this.loadNoteList();//触发父组件方法
                        }
                    }
                });
            },
            //根据订单号查询拣货说明，一个订单只有一个拣货说明，可以有多个客服备注
            loadNote(appId){
                getOrderJHNote(appId).then(res =>{
                    if(res.data != null && res.data != undefined){
                        this.jh_note = res.data;
                    }
                    if(res.data != null && res.data.hasOwnProperty("content")){
                        this.noteForm.note = res.data.content;
                    }
                    if(res.data != null && res.data.hasOwnProperty("id")){
                        this.noteForm.id = res.data.id;
                    }
                    if(res.data != null && res.data.color != null){
                        this.noteForm.color = res.data.color;
                        let className = '.color_' + this.colorArr.indexOf(res.data.color);
                        // document.querySelector(className).classList.remove('is-select-color');
                        let _dom = document.querySelector('.is-select-color');//获取有改clss的元素,该操作是移除所有‘is-select-color’ class
                        if(_dom){//如果存在改元素。则移除class
                            _dom.classList.toggle('is-select-color');
                        }
                        document.querySelector(className).classList.toggle('is-select-color');//给目标元素添加class
                    }
                });
            },
            cancel(){
                this.closeDialog();
                this.noteData.visible = false;
            },
            colorSelect(e,bgcolor){
                let _dom = document.querySelector('.is-select-color');
                if (_dom) {
                    _dom.classList.toggle('is-select-color');//当class为project的元素上没有这个CSS类时，它就新增这个CSS类；如果class为project的元素有了这个CSS类，它就是删除它。就是反转操作。
                }
                e.target.classList.toggle('is-select-color');
                this.noteForm.color=bgcolor;
            },
            typeChange(val){
                if(val == 0){
                    this.noteForm.color = null;
                    this.noteForm.id = null;
                    this.noteForm.note = null;
                }else{
                    this.noteForm.note = this.jh_note.content;
                    this.noteForm.id = this.jh_note.id;
                }
            },
            closeDialog(){
                this.$refs['noteForm'].resetFields();
                this.noteForm.id = null;
                this.noteForm.type = 1;
                this.noteForm.note = null;
                this.noteForm.color = null;
                this.jh_note.id = null;
                this.jh_note.content = null;
                this.jh_note.color = null;
            }
        }
    }
</script>

<style scoped>
    .colorClass .el-button.is-circle{border-radius: initial !important;}
    .is-select-color{box-shadow: 0 0 6px 3px #1318f5}
</style>
